/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { S3UploadItemMapper } from '@gh/common-shared-data';
import { entity } from '@gh/core-data';
import { FormulaMapper } from '../common';
import { ItemDetailsDto } from './item-details.dto';

export const ItemDetailsMapper = entity<ItemDetailsDto>({
  formula: FormulaMapper,
  picture: S3UploadItemMapper,
});
